import {Component, OnDestroy} from '@angular/core';
import {Observable} from 'rxjs';
import {MatDialogRef} from '@angular/material/dialog';
import {MatSnackBar} from '@angular/material/snack-bar';
@Component({
  selector: 'request-dialog',
  templateUrl: './candeactivate-dialog.component.html',
  standalone: false,
})
export class CandeactivateDialogComponent implements OnDestroy {
  constructor(
    public dialogRef: MatDialogRef<CandeactivateDialogComponent>,
    private snackBar: MatSnackBar,
  ) {}

  private alive: boolean = true;

  ngOnDestroy(): void {
    this.alive = false;
  }

  handleError(error: any, caught?: Observable<any>) {}
}
